import React from "react"
import PillBadgeM from "@common/components/badge/PillBadgeM"
import { getLiveSessionTypeMeta } from "@data/utility/liveSessionType"

const SessionTypeBadgeM = ({ type, style = {} }) => {
    const meta = getLiveSessionTypeMeta(type)

    return (
        <PillBadgeM
            label={meta?.label}
            color={meta?.color}
            backgroundColor={meta?.backgroundColor}
            style={style}
        />
    )
}

export default SessionTypeBadgeM
